/*
 * nf-theme-toggle.js — custom element <nf-theme-toggle> (Fase 1)
 * ---------------------------------------------------------------
 * O estado da pele e a persistencia vivem em window.nfTheme, definido pelo
 * script sincrono de snippets/nf-theme-head.liquid (anti-FOUC).
 * Aqui so tratamos interacao, aria-pressed e a view transition opcional.
 */
(function () {
  if (customElements.get('nf-theme-toggle')) return;

  class NFThemeToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.onClick = this.onClick.bind(this);
      this.sync = this.sync.bind(this);

      this.button.addEventListener('click', this.onClick);
      document.addEventListener('nf:theme-change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
      document.removeEventListener('nf:theme-change', this.sync);
    }

    get current() {
      if (window.nfTheme && typeof window.nfTheme.get === 'function') return window.nfTheme.get();
      return document.documentElement.getAttribute('data-nf-theme') === 'dark' ? 'dark' : 'light';
    }

    sync() {
      if (!this.button) return;
      this.button.setAttribute('aria-pressed', this.current === 'dark' ? 'true' : 'false');
    }

    onClick() {
      const next = this.current === 'dark' ? 'light' : 'dark';
      const apply = () => {
        if (window.nfTheme && typeof window.nfTheme.set === 'function') {
          window.nfTheme.set(next, true);
        } else {
          document.documentElement.setAttribute('data-nf-theme', next);
        }
      };

      let reduced = false;
      try {
        reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        reduced = false;
      }

      if (typeof document.startViewTransition === 'function' && !reduced) {
        document.startViewTransition(apply);
      } else {
        apply();
      }
    }
  }

  customElements.define('nf-theme-toggle', NFThemeToggle);
})();
